import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import React, { memo } from 'react';
import { ReportFilterDialog } from '../../ReportFilterDialog';
import ReportSelector from 'pages/ReportPage/components/ReportSelector';
import { RehabRedirectButton } from "../../RehabRedirectButton";
import { MenuTreeView } from "./MenuTreeView";

const ReportDrawerTabPanel = memo(() => (
  <Stack spacing={1} sx={{ width: '100%' }}>
    <Divider />
    <Stack spacing={1} sx={{ px: 1 }}>
      <ReportSelector />
      <ReportFilterDialog />
      <RehabRedirectButton />
    </Stack>
    <Divider />
    <MenuTreeView />
  </Stack>
));

export default ReportDrawerTabPanel;
